import React, { useRef, useState, useEffect } from "react";
import "./csscontact.css";
import { MdOutlineEmail } from "react-icons/md";
import { AiOutlineLinkedin } from "react-icons/ai";
import { BsWhatsapp } from "react-icons/bs";
import { useTranslation } from "react-i18next";
import axios from "axios";
import { baseURL } from "../../App";
import SkeletonLoader from "../Skeleton/SkeletonLoader";

const Contact = () => {
  const form = useRef();
  const { t } = useTranslation();
  const [result, setResult] = useState(null);
  const [contactInfo, setContactInfo] = useState(null);
  const [loading, setLoading] = useState(false);
  const API_URL = `${baseURL}/api/contact`;
  const API_URL_MESSAGE = `${API_URL}/message`;

  useEffect(() => {
    const fetchContactInfo = async () => {
      try {
        const response = await axios.get(API_URL);
        setContactInfo(response.data[response.data.length - 1]);
      } catch (error) {
        console.error("Error fetching contact info:", error);
      }
    };

    fetchContactInfo();
  }, [API_URL]);

  const isValidEmail = (email) => {
    const regex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
    return regex.test(email);
  };

  const sendContactForm = async (e) => {
    e.preventDefault();
    const formData = new FormData(form.current);
    const email = formData.get("email");

    if (!isValidEmail(email)) {
      setResult(
        "Error sending message, please make sure your email is a valid one"
      );
      return;
    }

    setLoading(true);
    setResult(null);

    try {
      await axios.post(API_URL_MESSAGE, {
        email: formData.get("email"),
        message: formData.get("message"),
        fullName: formData.get("fullName"),
      });
      // console.log(response.data);
      setResult("Message sent successfully!");
    } catch (error) {
      console.error(error);
      setResult("Error sending message");
    } finally {
      setLoading(false);
    }

    e.target.reset();
  };

  // Check if contactInfo is loaded
  if (!contactInfo) {
    return (
      <section id="contact">
        <h5>{t("contact.sub_title")}</h5>
        <h2>{t("contact.title")}</h2>
        <SkeletonLoader type="card" />
      </section>
    );
  }

  return (
    <section id="contact">
      <h5>{t("contact.sub_title")}</h5>
      <h2>{t("contact.title")}</h2>

      <div className="container contact_container">
        <div className="contact_options">
          <article className="contact_option">
            <MdOutlineEmail className="contact_option_icon" />
            <h4>Email</h4>
            <a
              href={`mailto:${contactInfo.email}`}
              target="_blank"
              rel="noreferrer"
            >
              {contactInfo.email}
            </a>
          </article>

          <article className="contact_option">
            <AiOutlineLinkedin className="contact_option_icon" />
            <h4>LinkedIn</h4>
            <a href={contactInfo.linkedin} target="_blank" rel="noreferrer">
              {t("contact.profile")}
            </a>
          </article>

          <article className="contact_option">
            <BsWhatsapp className="contact_option_icon" />
            <h4>WhatsApp</h4>
            <a href={contactInfo.whatsapp} target="_blank" rel="noreferrer">
              {t("contact.whatsapp")}
            </a>
          </article>
        </div>

        <form ref={form} onSubmit={sendContactForm}>
          <input
            type="text"
            name="fullName"
            placeholder={t("contact.full_name")}
            required
          />
          <input
            type="email"
            name="email"
            placeholder={t("contact.your_email")}
            required
          />
          <textarea
            name="message"
            id="message"
            cols="30"
            rows="10"
            placeholder={t("contact.your_message")}
            required
          ></textarea>
          <button type="submit" className="btn btnPrimary">
            {loading ? "Sending..." : t("submit")}
          </button>
          {loading && <p className="loading-message">Loading...</p>}
          {result && (
            <p
              className={`result-message ${
                result.includes("Error") ? "error" : "success"
              }`}
            >
              {result}
            </p>
          )}
        </form>
      </div>
    </section>
  );
};

export default Contact;
